import { Navigate, Route, Routes, useParams } from 'react-router'
import { AssignNumberStepsRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber'
import { BuyNumberStepsRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/BuyNumber'
import { InboxesRoutes } from 'pages/settings/pages/inboxes/route/type'
import { AddNumberFromAppRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp'
import { TextEnableLandlineRouter } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline'
import { SettingsRoutes } from 'pages/settings/route/type'

export const AddNumberMethodsRouter = () => {
  const { id } = useParams()

  return (
    <Routes>
      <Route path={`${InboxesRoutes.assignNumber}/*`} element={<AssignNumberStepsRouter />} />
      <Route path={`${InboxesRoutes.buyNumber}/*`} element={<BuyNumberStepsRouter />} />
      <Route path={`${InboxesRoutes.addNumberFromApp}/*`} element={<AddNumberFromAppRouter />} />
      <Route
        path={`${InboxesRoutes.textEnableLandline}/*`}
        element={<TextEnableLandlineRouter />}
      />
      <Route
        path={'*'}
        element={
          <Navigate
            to={`/${SettingsRoutes.root}/${InboxesRoutes.root}/${id}/${InboxesRoutes.numbers}`}
            replace
          />
        }
      />
    </Routes>
  )
}
